export const API_URL = "https://insight-backend-host.space:3030/api";

// TODO: move to env

